<div class="myDiv">
  <div class="no-print" *ngIf="showHelperInput">
    <mat-card>
      <mat-card-title>
        {{ settings.lang.volunteerInfo }}
        <div>
          <mat-menu #appMenu77>
            <button
              mat-menu-item
              *ngIf="familyLists.helper"
              (click)="editHelper()"
            >
              <mat-icon>edit</mat-icon> {{ settings.lang.volunteerInfo }}
            </button>
            <button mat-menu-item (click)="clearHelperInfo()">
              <mat-icon>clear</mat-icon>{{ settings.lang.clearHelperInfo }}
            </button>
            <button mat-menu-item (click)="saveHelper()" *ngIf="showSave()">
              {{ settings.lang.saveHelperInfoAndMoveToNextHelper }}
            </button>
            <button
              *ngIf="!settings.showCompanies"
              mat-menu-item
              (click)="settings.showCompanies = true; changeShowCompany()"
            >
              {{ settings.lang.showHelperCompany }}
            </button>
            <button
              *ngIf="settings.showCompanies"
              mat-menu-item
              (click)="settings.showCompanies = false; changeShowCompany()"
            >
              {{ settings.lang.hideHelperCompany }}
            </button>
          </mat-menu>

          <button mat-icon-button [matMenuTriggerFor]="appMenu77">
            <mat-icon>psychology</mat-icon>
          </button>
        </div>
      </mat-card-title>

      <mat-form-field
        appearance="outline"
        class="full-width-form-field dense-form-field"
      >
        <mat-label>{{ settings.lang.volunteerIdentifier }}</mat-label>
        <input
          matInput
          [(ngModel)]="identifier"
          (input)="onIdentifierInput()"
          type="{{getKeyboardType()}}"
          #identifierInput
          [matAutocomplete]="auto"
          #autocompleteTrigger="matAutocompleteTrigger"
        />
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="searchIdentifier()">
          <mat-option *ngFor="let s of helperSuggestions" [value]="s.phone" >
            <div class="search-autocomplete-option">
              <div class="search-result-text"><span>{{ s.name }}</span><span>{{ s.phone }}</span></div>
              <span *ngIf="s.assignedDeliveries > 0" class="secondary-text">({{s.assignedDeliveries}} {{ settings.lang.ActiveDeliveries }})</span>
            </div>
          </mat-option>
        </mat-autocomplete>
        <div matSuffix style="display: flex; margin-left: 8px; gap: 4px;">
          <mat-icon *ngIf="dialog.isScreenSmall()" (click)="toggleKeyboardType()" class="clickable-icon">keyboard</mat-icon>
          <mat-icon (click)="clearHelperInfo()" class="clickable-icon">clear</mat-icon>
        </div>
      </mat-form-field>
      <data-area
        [settings]="area"
        *ngIf="identifier && isValidPhone() && showHelperInput && helper"
      ></data-area>
    </mat-card>
  </div>

  <br *ngIf="showHelperInput && (!helper || !helper.name)" />
  <a
    href="https://youtu.be/8LCeQRQPL1U"
    *ngIf="showHelperInput && (!helper || !helper.name) && settings.showVideo()"
    target="_blank"
    class="help no-print"
    >{{ settings.lang.asignVideoHelp }}</a
  >
  <div *ngIf="helper && helper.name && helper.name.length >= 2">
    <mat-card class="no-print">
      <mat-card-title>
        {{ settings.lang.asignDeliveriesTo }} {{ helper.name }}
        <div>
          <mat-menu #filterOptionsMenu="matMenu">
            <div style="display: flex; flex-direction: column">
              <mat-checkbox
                class="mat-menu-item"
                [(ngModel)]="o.inputValue"
                (change)="changeShowCompany()"
                *ngFor="let o of filterOptions"
                >{{ o.metadata.caption }}</mat-checkbox
              >
            </div>
          </mat-menu>
          <button mat-icon-button [matMenuTriggerFor]="filterOptionsMenu">
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </mat-card-title>
      <mat-card-subtitle *ngIf="helperStats">
        👍 {{ helperStats }}
      </mat-card-subtitle>
      <div class="filter-div">
        <mat-form-field
          appearance="outline"
          class="full-width-form-field dense-form-field"
          *ngIf="settings.showGroupsOnAssing"
        >
          <mat-label>{{ settings.lang.familyGroups }}</mat-label>
          <select
            matNativeControl
            class="form-control"
            #lang
            (change)="refreshBaskets()"
            [(ngModel)]="filterGroup"
          >
            <option value="">{{ settings.lang.allGroups }}</option>
            <option
              *ngFor="let g of groups; trackBy: trackGroup"
              value="{{ g.name }}"
            >
              {{ g.name }} - {{ g.familiesCount }}
            </option>
          </select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="full-width-form-field dense-form-field"
          *ngIf="settings.showCityOnAssing"
        >
          <mat-label>{{ settings.lang.distributionCity }}</mat-label>
          <select
            matNativeControl
            class="form-control"
            #city
            (change)="selectCity()"
            [(ngModel)]="filterCity"
          >
            <option value="">{{ settings.lang.allCities }}</option>
            <option
              *ngFor="let c of cities; trackBy: trackCity"
              value="{{ c.name }}"
            >
              {{ c.name }} - {{ c.unassignedFamilies }}
            </option>
          </select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="full-width-form-field dense-form-field"
          *ngIf="settings.showAreaOnAssing"
        >
          <mat-label>{{ settings.lang.region }}</mat-label>
          <select
            matNativeControl
            class="form-control"
            #city
            (change)="selectCity()"
            [(ngModel)]="filterArea"
          >
            <option [value]="settings.lang.allRegions">
              {{ settings.lang.allRegions }}
            </option>
            <option
              *ngFor="let c of areas; trackBy: trackCity"
              value="{{ c.name }}"
            >
              {{ c.name }} - {{ c.unassignedFamilies }}
            </option>
          </select>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          class="full-width-form-field dense-form-field"
          *ngIf="settings.showBasketOnAssing"
        >
          <mat-label>{{ settings.lang.basketType }}</mat-label>
          <select
            matNativeControl
            class="form-control"
            #lang
            (change)="refreshBaskets()"
            [(ngModel)]="basketType"
          >
            <option
              *ngFor="let b of baskets; trackBy: trackBasket"
              [ngValue]="b"
            >
              {{ b.name }}
              <span *ngIf="b != allBaskets">- {{ b.unassignedFamilies }}</span>
            </option>
          </select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="full-width-form-field dense-form-field"
          *ngIf="settings.showNumOfBoxesOnAssing"
        >
          <mat-label>{{ settings.lang.numOfFamilies }}</mat-label>
          <input
            matInput
            type="number"
            id="numOfBaskets"
            [(ngModel)]="numOfBaskets"
          />
          <div matSuffix style="display: flex">
            <button mat-icon-button (click)="add(1)">
              <mat-icon>add</mat-icon>
            </button>
            <button mat-icon-button (click)="add(-1)">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
        </mat-form-field>

        <mat-checkbox
          [(ngModel)]="preferRepeatFamilies"
          style="width: auto"
          *ngIf="showRepeatFamilies"
        >
          {{ settings.lang.prioritizeRepeatFamilies }} ({{
            repeatFamilies.length
          }})
        </mat-checkbox>
        <div *ngIf="hasPreferred()" style="margin-bottom: 4px">
          {{ preferredText() }}
        </div>
      </div>

      <div
        class="no-print"
        style="display: flex; justify-content: center"
        #assignButton
      >
        <button
          mat-flat-button
          (click)="assignItem()"
          [disabled]="basketType.unassignedFamilies == 0 || assigning"
          class="startButtonPart"
        >
          {{
            assigning
              ? settings.lang.inProgress
              : basketType.unassignedFamilies == 0
              ? settings.lang.noDeliveriesLeft
              : familyLists.allFamilies.length > 0
              ? settings.lang.asignClosestDelivery
              : repeatFamilies.length > 0 &&
                preferRepeatFamilies &&
                repeatFamilies.length > 0
              ? settings.lang.assignRepeatFamily
              : helper.preferredDistributionAreaAddress ||
                helper.preferredFinishAddress
              ? settings.lang.asignClosestDelivery
              : settings.lang.asignAnyDelivery
          }}
          -
          {{ getBasketsToClick() }}
        </button>
        <button
          class="endButtonPart"
          [matMenuTriggerFor]="basketMenu"
          mat-flat-button
          style="padding-left: 0; padding-right: 0; min-width: 38px"
          *ngIf="baskets.length"
        >
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #basketMenu="matMenu">
          <button
            mat-menu-item
            (click)="addRepeat()"
            *ngIf="preferRepeatFamilies && repeatFamilies.length > 0"
          >
            {{ settings.lang.addRepeatFamilies }}
          </button>
          <button mat-menu-item (click)="addSpecial()" *ngIf="specialFamilies">
            {{ settings.lang.specialFamilies }} - {{ specialFamilies }}
          </button>
          <button mat-menu-item (click)="addSpecific()">
            {{ settings.lang.selectDeliveryByName }}
          </button>
          <button mat-menu-item (click)="assignOnMap()">
            {{ settings.lang.selectDeliveryOnMap }}
          </button>
          <button mat-menu-item (click)="addStreet()">
            {{ settings.lang.selectDeliveryByStreet }}
          </button>
          <button mat-menu-item (click)="addBuilding()">
            {{ settings.lang.assignBuildings }}
          </button>

          <button mat-menu-item (click)="moveBasktesFromOtherHelper()">
            {{ settings.lang.transferDeliveriesFromOtherVolunteer }}
          </button>
        </mat-menu>
      </div>
    </mat-card>

    <!--
    <input type="checkbox" [(ngModel)]="this.useGoogleOptimization">
    <button (click)="doRefreshRoute()">Run Refresh Route</button>-->
    <app-helper-families
      #helperFamilies
      [familyLists]="familyLists"
      [partOfAssign]="true"
      [partOfReview]="!showHelperInput"
      (assignmentCanceled)="assignmentCanceled()"
      (assignSmsSent)="smsSent()"
    >
    </app-helper-families>
  </div>
</div>
